import React, { useCallback, useRef, useEffect } from 'react';

export const useChartResize = (chartRef, initChart = () => {}) => {
    const resizeTimeoutRef = useRef();

    useEffect(() => {
        return () => {
        if (resizeTimeoutRef.current) {
            clearTimeout(resizeTimeoutRef.current);
        }
        };
    }, []);

    const performResize = useCallback(() => {
        if (chartRef.current) {
            if (resizeTimeoutRef.current) {
                clearTimeout(resizeTimeoutRef.current);
            }
            
            resizeTimeoutRef.current = setTimeout(() => {
                initChart();
            }, 301);
        }
    }, [chartRef, initChart]);

    return performResize
}
